var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18487 9.68198C6.46518 10.1226 6.8228 10.4871 7.23348 10.7509C7.64417 11.0147 8.0983 11.1716 8.56508 11.2109C9.03187 11.2502 9.50038 11.171 9.93885 10.9787C10.3773 10.7864 10.7755 10.4855 11.1063 10.0964L13.0645 7.79416C13.6589 7.07049 13.9879 6.10125 13.9805 5.09519C13.973 4.08914 13.6298 3.12676 13.0247 2.41534C12.4196 1.70393 11.6011 1.30039 10.7454 1.29165C9.88968 1.28291 9.0653 1.66966 8.44978 2.3686L7.32711 3.68087M8.79572 8.14717C8.51541 7.70658 8.15778 7.34202 7.7471 7.07822C7.33642 6.81442 6.88229 6.65755 6.4155 6.61824C5.94872 6.57894 5.48021 6.65812 5.04174 6.85042C4.60327 7.04272 4.20511 7.34364 3.87426 7.73277L1.91612 10.035C1.32164 10.7587 0.992688 11.7279 1.00012 12.734C1.00756 13.74 1.35078 14.7024 1.95588 15.4138C2.56097 16.1252 3.37951 16.5288 4.23521 16.5375C5.0909 16.5462 5.91529 16.1595 6.5308 15.4605L7.64694 14.1483",
    strokeWidth: 1.90577,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.c9408595.svg";
export { ForwardRef as ReactComponent };